<template>
    <div class="welcomeContactCard">
        <TruePanel v-if="!contactInfoVisible">
            <div class="flex-row">
                <div class="welcomeContactCard-image">
                    <div class="avatar" :style="`background-image: url(/img/avatarMax.png)`"></div>
                </div>
                <div class="welcomeContactCard-text">
                    <b>Hello! I’m Maxwell B,</b> Welcome to truesecurity. If you need anything, our guides are ready to help.
                </div>
            </div>
            <div class="flex-row">
                <div class="welcomeContactCard-action">
                    <button type="button"
                            class="button outline"
                            @click="toggleTalkWithGuideVisible">Talk with a guide</button>
                </div>
            </div>
        </TruePanel>
        <TruePanel v-if="contactInfoVisible">
            <div class="flex-row">
                <div class="welcomeContactCard-image">
                    <img src="/img/test-ph.jpg"
                         alt="">
                </div>
                <div class="welcomeContactCard-text">
                    <span class="contactOption"><img src="/img/icon-phone.png" alt="" /> {{ supportNumber }}</span>
                    <span class="contactOption" @click="showChat"><img src="/img/icon-chat-bubbles.png" alt=""  /> Live chat</span>
                </div>
            </div>
            <div class="flex-row">
                <div class="welcomeContactCard-action">
                    <button type="button"
                            class="button outline"
                            @click="hideContactInfo">Close</button>
                </div>
            </div>
        </TruePanel>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import TruePanel from "./TruePanel.vue";
export default {
  data: () => ({
    contactInfoVisible: false
  }),
  computed: {
    ...mapState(["supportNumber"])
  },
  methods: {
    ...mapActions(["showChat"]),
    ...mapMutations(["toggleTalkWithGuideVisible"]),

    showContactInfo() {
      this.contactInfoVisible = true;
    },

    hideContactInfo() {
      this.contactInfoVisible = false;
    }
  },
  components: {
    TruePanel
  }
};
</script>

<style lang="css"></style>
